import React from 'react';
import { motion } from 'framer-motion';
import { Section, CHECKOUT_URL, PRICE_USD, PRICE_USD_FULL, PRICE_USD_NEXT } from './Shared';
export const Pricing = () => <Section id="pricing" glow className="bg-brand-paper/70 rounded-sm my-12 border border-brand-gold/40" data-id="element-203" data-mp="2oipkp2kbb9hj">
    <div className="text-center mb-10 pt-10" data-id="element-204" data-mp="2jj4b7y7iniqk">
      <span className="inline-block border border-brand-gold/60 text-brand-goldDark font-seal text-[10px] md:text-xs uppercase tracking-seal px-4 py-1.5 rounded-sm mb-6" data-id="element-205" data-mp="2jkeauru0oyzb">
        Oferta de lanzamiento
      </span>
      <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-purpleDark" data-id="element-206" data-mp="1rujcy6s3g0z1">
        Tu <span className="headline-shine" data-id="element-207" data-mp="25q4uxtzwtkhy">Mega Pack Chi Kung</span>
      </h2>
      <p className="text-brand-text/70 mt-4 text-sm md:text-base" data-id="element-208" data-mp="20sd1gvjm9qbn">
        El precio de lanzamiento cierra pronto. Después sube a {PRICE_USD_NEXT}.
      </p>
    </div>

    <div className="max-w-2xl mx-auto" data-id="element-209" data-mp="3c8tdeevypotr">
      <div className="relative rounded-sm" data-id="element-210" data-mp="3c7s3weulhae5">
        <span className="glow-frame" aria-hidden="true" data-id="element-211" data-mp="3vzp4rftr067y" />
        <div className="relative z-[1] w-full text-left rounded-sm p-6 md:p-8 bg-brand-paper border border-brand-purpleDark/10" data-id="element-212" data-mp="3vz7323obgzsn">
          <p className="font-seal text-[10px] uppercase tracking-seal text-brand-goldDark mb-4" data-id="element-213" data-mp="9s8rl01kbk7l">
            El sistema más completo
          </p>

          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-214" data-mp="eq0l1yhuvedw">
            <div className="min-w-0" data-id="element-215" data-mp="3daa61s1jbt6q">
              <h3 className="font-display font-bold text-xl md:text-2xl text-brand-purpleDark leading-tight" data-id="element-216" data-mp="3d74g6al30n9y">
                Mega Pack Chi Kung
              </h3>
              <p className="text-sm text-brand-muted mt-1.5" data-id="element-217" data-mp="3n6d9d184hxv9">
                3 tomos + 6 bonus · Más de 190 páginas
              </p>
              <p className="text-sm text-brand-text/80 mt-3 max-w-sm" data-id="element-218" data-mp="3rzohr6sl2mpa">
                El sistema integral de sesiones prediseñadas y protección
                energética para el terapeuta profesional.
              </p>
            </div>

            <div className="shrink-0 border-t border-brand-gold/30 pt-5 text-center sm:border-t-0 sm:border-l sm:pt-0 sm:pl-6 sm:text-right" data-id="element-219" data-mp="2rg3525fx02oi">
              <p className="text-sm text-brand-muted line-through leading-none" data-id="element-220" data-mp="2mhi5874krl0l">
                {PRICE_USD_FULL}
              </p>
              <p className="font-display font-bold text-4xl md:text-5xl leading-none mt-2 text-brand-purpleDark" data-id="element-221" data-mp="2w7l952d8ijdp">
                {PRICE_USD}
              </p>
              <p className="text-xs text-brand-muted mt-3 max-w-[15rem] mx-auto sm:mx-0 leading-relaxed" data-id="element-222" data-mp="28i8z60a327ac">
                Pago único · El importe se aplica directamente en euros
              </p>
            </div>
          </div>
        </div>
      </div>

      <motion.a href={CHECKOUT_URL} whileHover={{
      scale: 1.015
    }} whileTap={{
      scale: 0.985
    }} transition={{
      duration: 0.15,
      ease: [0.23, 1, 0.32, 1]
    }} className="mt-6 w-full inline-flex items-center justify-center px-6 py-5 text-base md:text-lg font-semibold uppercase tracking-wide text-brand-surface purple-gradient-bg rounded-full ring-1 ring-brand-goldLight/50 animate-glow-pulse relative overflow-hidden cta-shimmer" data-id="element-223" data-mp="2dgk7g6kqc9qg">
        <span className="relative z-10" data-id="element-224" data-mp="5741tfysgt5h">Quiero mi Mega Pack — {PRICE_USD}</span>
      </motion.a>

      <p className="text-center text-xs md:text-sm text-brand-muted pt-5" data-id="element-225" data-mp="3nhfza1njrwoa">
        Garantía de 7 días · Descarga inmediata · Pago seguro · Tarjeta
      </p>
    </div>
  </Section>;